import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "InstarVision v3 für macOS",
  "path": "/Software/macOS/InstarVision/PTZ/",
  "dateChanged": "2018-01-25",
  "author": "Mike Polinowski",
  "excerpt": "Richten Sie Ihren Videoleinwandbereich mit einem Klick im Menü Layout ein. Wählen Sie ein Layout, das Ihren Anforderungen und der Anzahl der aktiven Kameras entspricht. Das Layout wird immer auf die Standardeinstellung zurückgesetzt, wenn Sie die Software neu starten - die Startvorgabe kann im Menü System eingestellt werden.",
  "image": "../P_SearchThumb_InstarVision_Windows.png",
  "social": "/images/Search/P_SearchThumb_InstarVision_Windows.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Windows-InstarVision_white.webp",
  "chapter": "Software"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEOHelmet title='InstarVision v3 für macOS' dateChanged='2018-01-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Das InstarVision Surveillance Center ist eine IP-Kamera-Software, die 64 Kameras gleichzeitig unterstützen kann, einschließlich Netzwerkkameras, USB-Kameras mit Fernzugriff und Sekundärinstallationen der Software.' image='/images/Search/P_SearchThumb_InstarVision_Windows.png' twitter='/images/Search/P_SearchThumb_InstarVision_Windows.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Software/macOS/InstarVision/PTZ/' locationFR='/fr/Software/macOS/InstarVision/PTZ/' crumbLabel="PTZ" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/9d78f8381141dc3cb5ef7628423b929e/29114/Banner_en-InstarVision2-0_Camera-PTZ.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "16.521739130434785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAgElEQVQI143HMQrCQBRF0b8VXZ+FnWJ6i8xYjdiohehWbGxTTMQFGKtAfkicDOEKBlvJg8PjCn2AVuFdQ9dAUw1NZOyccyxXCcQWMZlif3zA3iM2j5i8w/jwV+oDm0dPsrYs5jPSTBE5vpD9EzkUyKlELoqcdfhRaqbbK5Pd7dsf0sjAzSH1eqAAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/9d78f8381141dc3cb5ef7628423b929e/e4706/Banner_en-InstarVision2-0_Camera-PTZ.avif 230w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/d1af7/Banner_en-InstarVision2-0_Camera-PTZ.avif 460w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/7f308/Banner_en-InstarVision2-0_Camera-PTZ.avif 920w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/e1c99/Banner_en-InstarVision2-0_Camera-PTZ.avif 1380w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/76ea5/Banner_en-InstarVision2-0_Camera-PTZ.avif 1840w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/f696c/Banner_en-InstarVision2-0_Camera-PTZ.avif 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/9d78f8381141dc3cb5ef7628423b929e/a0b58/Banner_en-InstarVision2-0_Camera-PTZ.webp 230w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/bc10c/Banner_en-InstarVision2-0_Camera-PTZ.webp 460w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/966d8/Banner_en-InstarVision2-0_Camera-PTZ.webp 920w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/445df/Banner_en-InstarVision2-0_Camera-PTZ.webp 1380w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/78de1/Banner_en-InstarVision2-0_Camera-PTZ.webp 1840w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/882b9/Banner_en-InstarVision2-0_Camera-PTZ.webp 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/9d78f8381141dc3cb5ef7628423b929e/81c8e/Banner_en-InstarVision2-0_Camera-PTZ.png 230w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/08a84/Banner_en-InstarVision2-0_Camera-PTZ.png 460w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/c0255/Banner_en-InstarVision2-0_Camera-PTZ.png 920w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/b1001/Banner_en-InstarVision2-0_Camera-PTZ.png 1380w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/161ec/Banner_en-InstarVision2-0_Camera-PTZ.png 1840w", "/de/static/9d78f8381141dc3cb5ef7628423b929e/29114/Banner_en-InstarVision2-0_Camera-PTZ.png 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/9d78f8381141dc3cb5ef7628423b929e/c0255/Banner_en-InstarVision2-0_Camera-PTZ.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "kamera-schwenken-neigen--zoomen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#kamera-schwenken-neigen--zoomen",
        "aria-label": "kamera schwenken neigen  zoomen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Kamera Schwenken, Neigen & Zoomen`}</h2>
    <h3 {...{
      "id": "ptz-kontrolle",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#ptz-kontrolle",
        "aria-label": "ptz kontrolle permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`PTZ Kontrolle`}</h3>
    <p>{`Das PTZ Menü gibt Ihnen Kontrolle über die Pan (horizontaler Schwenk), Tilt (vertikaler Schwenk) und Zoom Funktion Ihrer Kamera.`}</p>
    <p>{`Die Taste `}<strong parentName="p">{`Links`}</strong>{` bewegt die Kamera nach links, `}<strong parentName="p">{`Rechts`}</strong>{` schwenkt nach rechts und `}<strong parentName="p">{`Up`}</strong>{` und `}<strong parentName="p">{`Down`}</strong>{` kippen die Kamera nach oben bzw. nach unten. Die Tasten `}<strong parentName="p">{`Zoom-in`}</strong>{` und Camera `}<strong parentName="p">{`Zoom-out`}</strong>{` aktivieren den optischen Zoom Ihrer Kamera - wenn Ihre Kamera eine Vario-Linse verwendet. InstarVision unterstützt auch eine digitale Zoomfunktion für Kameramodelle ohne Zoomlinse - wählen Sie einfach das Ansichtsfenster Ihrer Kamera und drehen Sie das Mausrad, um den Kamerarahmen zu vergrößern oder zu verkleinern. Ziehen Sie das Bild per Drag & Drop, um Ihre Kamera virtuell zu schwenken und zu neigen.`}</p>
    <h3 {...{
      "id": "kamera-tour",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#kamera-tour",
        "aria-label": "kamera tour permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Kamera Tour`}</h3>
    <p>{`Stellen Sie das Drop-down Menü auf Gehe zu Position und wählen Sie ein Preset aus der Liste (1-8 bzw. 1-15 je nach Kameramodell) um die Kamera zu der `}<strong parentName="p">{`Preset Position`}</strong>{` fahren zu lassen - diese gespeicherten Positionen sind die gleichen, die Sie über die Weboberfläche der Kamera festlegen können. Um eine Position über die InstarVision zu speichern, bewegen Sie die Kamera bitte in die gewünschte Position, wählen Sie `}<strong parentName="p">{`Speichere Position`}</strong>{` aus dem Drop-down Menü aus und klicken Sie auf die Nummer, die Sie der Position zuweisen möchten. Beachten Sie bitte - diese Funktion überschreibt ggf. schon über die Weboberfläche festgelegte Positionen!`}</p>
    <p>{`Die Kamera Preset Positionen können auch verwendet werden um eine Kamera Tour zu programmieren. Wählen Sie aus wie viele Zyklen (1 - 999999999) Ihre Kamera über die gewünschten Preset Positionen fahren soll und legen Sie eine Pause (Minimum 10s) fest, in der die Kamera auf den Positionen verharren soll. In dem gegebenen Beispiel (s.u.) wird die Kamera 999999-mal die Positionen 1-2-3 abfahren und jeweils 999s auf jeder Position verbleiben. Klicken Sie auf `}<strong parentName="p">{`Start`}</strong>{` um die Tour mit Position 1 zu beginnen. Die Anzahl an Zyklen zählt mit jeder beendeten Tour runter. Die Tour wird automatisch stoppen, wenn diese Wert 0 erreicht hat. Sie können die Tour jederzeit beenden, indem Sie den `}<strong parentName="p">{`Stopp`}</strong>{` Button betätigen`}</p>
    <h4 {...{
      "id": "wie-programmiert-man-eine-ptz-kamera-tour",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#wie-programmiert-man-eine-ptz-kamera-tour",
        "aria-label": "wie programmiert man eine ptz kamera tour permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Wie programmiert man eine PTZ Kamera Tour`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/b44f9d38769d49cd86555dded7384803/2bef9/InstarVision2_PTZ-Tour_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACt0lEQVQoz2WSa0gTUBTHr4/cIzPooVNXWV+iEokKA6OHSwhK3bQ+RGbQg9ZLSQeaYUVFlJZpZC+EispZuWlogmHLLKL6kKtFD1f2cGDGXGkvs9p+sTvwgx44nHP58/+dezlXWJvbuHKzjZqWB1hutXKh1kLJ2TKKDhZgKs6lvOoE8QkJRESMY87ceSxYsBCdLoUlS5JJTJxP3NRpREZpqCivoL6uHmHcZcS0J5/Soq0UmlazZksqu4o2c+xwATtyMsnbloU2JhIhBFVVVbhcLhwOB45nDjo6OtAtTZFandWC8/UrxLHdWzlXdoirFUfZW5jNtoJMTh7Pp/nCKRouVtJovkxC/Cxpstls+MPj8fBrYED2ekOG1O4/tvNjEET14X1U5q6nfPtazuVmUbxhOWWmTGqP5NBcvJGmgmymT9FKU2NjI54vX/g9+IevfX243e4hYN2tBzi7vyPqT5dyptBISd4myoyrqN1t5M6BHK7nruS8aT2X9puYHBs7BPRHX28PP7/14fX6SE1Nk5q9/Qk9v72IbP0KUpISSV6UhC5pDqsWz2Odbj6GpNlkZBrIz9tJXNw0hAiiqamJzwPw0Omhs6cf379B0vQGRFAIdvtTOUxMiNTICSIoWApCBAdS9kFSU6jUsvq3eOORm/KGTmruuvjg8qA36KXW3m4PALWTJhMSOgqlSo1CqUShVKFUqmT1n1Xq0ajU4dJ0reYab51unj7roqX1Je2OLgzDgbHaANAPCFMoR6T/durRAaDZXC1NPt9f+j09/PjqJi09AHQ8fx4AaqJj5NP80OCQ0BEZMiqMMIVKmqxWi1yEz+vlXW8/H395WZGWLrWW2zZ63W7EjJnxjJ8wkShNtPzxwzNKE0N0jJbwMRFUm810f/rE+zdOjt97QY7NybL0DMZGjKWk9ChWi4X/djX08nDUq60AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/b44f9d38769d49cd86555dded7384803/e4706/InstarVision2_PTZ-Tour_01.avif 230w", "/de/static/b44f9d38769d49cd86555dded7384803/d1af7/InstarVision2_PTZ-Tour_01.avif 460w", "/de/static/b44f9d38769d49cd86555dded7384803/7f308/InstarVision2_PTZ-Tour_01.avif 920w", "/de/static/b44f9d38769d49cd86555dded7384803/e3723/InstarVision2_PTZ-Tour_01.avif 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/b44f9d38769d49cd86555dded7384803/a0b58/InstarVision2_PTZ-Tour_01.webp 230w", "/de/static/b44f9d38769d49cd86555dded7384803/bc10c/InstarVision2_PTZ-Tour_01.webp 460w", "/de/static/b44f9d38769d49cd86555dded7384803/966d8/InstarVision2_PTZ-Tour_01.webp 920w", "/de/static/b44f9d38769d49cd86555dded7384803/a9a89/InstarVision2_PTZ-Tour_01.webp 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/b44f9d38769d49cd86555dded7384803/81c8e/InstarVision2_PTZ-Tour_01.png 230w", "/de/static/b44f9d38769d49cd86555dded7384803/08a84/InstarVision2_PTZ-Tour_01.png 460w", "/de/static/b44f9d38769d49cd86555dded7384803/c0255/InstarVision2_PTZ-Tour_01.png 920w", "/de/static/b44f9d38769d49cd86555dded7384803/2bef9/InstarVision2_PTZ-Tour_01.png 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/b44f9d38769d49cd86555dded7384803/c0255/InstarVision2_PTZ-Tour_01.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><strong parentName="p">{`1`}</strong>{` - Öffnen Sie das PTZ Menü und wählen Sie Speichere Position aus dem Drop-down Menü unterhalb des PTZ Kontrollpads aus. Abhängig von Ihrem Kameramodell werden Ihnen 8 oder 15 Kamerapositionen angezeigt, die Sie für die PTZ Tour verwenden können.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/07684d939f2637d466d3e0e27ea98cda/2bef9/InstarVision2_PTZ-Tour_02.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACrUlEQVQoz2WSa0gTUBTHr4/cpqFRplPXAwuiEomIgmVGYkUPyKwP1TbDilaWkg58ZUVJmK9mZA+zMsxS22agBUZl+MG+pUUmflaYuOmWbosK8xe7CyE8cLj38uf/O+cejrB199LyqpfWt31Y33ygyWKl8n4tJeWFmMryMDfeIik5mcioxaRsSyUlZRu7du0mPX0n2q0pJK5azdIYNXXmOl52dCCMxUZMlwqoKjlLkekIx87sp7jkNDUVhZzPzSQ/R4cmPgYhBA8bG7Hbxxj6NsTg4CAjIyNkZByUmtVmY3h4GFFTepaG2uu01VVzuchATmEmt28W0N10h84n9XQ9f0py0npp6uzsxB9TU1N4vV55zzp+XGr9/QPMzs4inlVcoT4vG/M5PQ15OspO7KXWlInlRi7dZSd5XWhgzQqNNNmsVtxuN16fj+npaVwuF3qDQWp9fR/xeDyIl3eruFdkpDL/FLXGw1hKjfRcy+VF3iEem7JpvmpiuSZBmixWq+zKMe6QMH8cOXpMap8+9WP/OYswHNhHunYzO1K1pGk3cnj7JrLStpCh3cDBzAwK8i+wcmUiQgRha23jh8fD6Ogodrsdn8+H3pAltYHPX2QBER2jlhVEUDAiKAQhggMp70FSU6jCAx2azfyanGTC5WLC6ZRAnU4fmOHAQACoWbackNAFKFXhKJRKFEoVSqVKnv63KjwCVcRCaWppeSZNMzMzOJxOxsYdc1+eAyZoAkA/IEyhnJf+7sL/AZseP5KD93p9uJ3j/J7+jl4f6PDr18EAUB0XL7/mhwaHhM7LkAVhhClU/62NP/qn/vDAAYd0gbV5976HyYkJxNp1SSyJXkqsOo6YWPW8jFXHo45PIDJqERcvltHV9QpLezt3nrZT3tzBzj37iIpaRFV1DTabjb9EgvcL7ufV/gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/07684d939f2637d466d3e0e27ea98cda/e4706/InstarVision2_PTZ-Tour_02.avif 230w", "/de/static/07684d939f2637d466d3e0e27ea98cda/d1af7/InstarVision2_PTZ-Tour_02.avif 460w", "/de/static/07684d939f2637d466d3e0e27ea98cda/7f308/InstarVision2_PTZ-Tour_02.avif 920w", "/de/static/07684d939f2637d466d3e0e27ea98cda/e3723/InstarVision2_PTZ-Tour_02.avif 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/07684d939f2637d466d3e0e27ea98cda/a0b58/InstarVision2_PTZ-Tour_02.webp 230w", "/de/static/07684d939f2637d466d3e0e27ea98cda/bc10c/InstarVision2_PTZ-Tour_02.webp 460w", "/de/static/07684d939f2637d466d3e0e27ea98cda/966d8/InstarVision2_PTZ-Tour_02.webp 920w", "/de/static/07684d939f2637d466d3e0e27ea98cda/a9a89/InstarVision2_PTZ-Tour_02.webp 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/07684d939f2637d466d3e0e27ea98cda/81c8e/InstarVision2_PTZ-Tour_02.png 230w", "/de/static/07684d939f2637d466d3e0e27ea98cda/08a84/InstarVision2_PTZ-Tour_02.png 460w", "/de/static/07684d939f2637d466d3e0e27ea98cda/c0255/InstarVision2_PTZ-Tour_02.png 920w", "/de/static/07684d939f2637d466d3e0e27ea98cda/2bef9/InstarVision2_PTZ-Tour_02.png 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/07684d939f2637d466d3e0e27ea98cda/c0255/InstarVision2_PTZ-Tour_02.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><strong parentName="p">{`2`}</strong>{` - Bewegen Sie jetzt die Kamera in die Position Eins Ihrer Kamera Tour. Klicken Sie danach auf die 1 unterhalb des Drop-down Menüs. Die Zahl wird kurz in einem stärkeren Font dargestellt und die Position gespeichert.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/4ff481310257981b89a808f5479e84c8/2bef9/InstarVision2_PTZ-Tour_03.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACsUlEQVQoz2WQXUjTYRTG/+nmPgqdpm5qBmoXFXVbYBqRqcm6mGSabpqbmQUqJn0QKURq0AfVRSloqZVm2jZRy0BKiFh3flQWQl01UtyWpm6ZYf6idyWBBx7e8/LwPOc5R3o5OEBDXRWW7ExKj5q5XlFMY4UZe00lxXlZ6DPS2RSfgCY0nKSk3SQlJZOWls6+lFQSE3cRn7CJiEgdN2/cpNtuR2q8VUd5uZEicz4lxRaqT1Vw3HCA00X5nCk7wdGcLLQR4UiSRFNTExMTk3x4/4Gxsfd8djoxZGYKzmqzMT4+jtT/sJmqsyepq73Itcu1FBpzsBjSMaTspSTbwKWyQqKjooSop6eHPzU7N4fX4wGfj4L8AsEND4+wvLyM5Ojrpv/eHZ60NeNwOKhvaKC6rIBjKZtpv2im0qQnOFjjT2G1MjM9jXdhgbkvX5h++xbT4VzBORyvmZ+fR/rYUc+bR02MdjTy6n49A/1PaWlt5UKhnmeXTSTv2E5YaKgQdXV1iYQul4tplwsWFzmcmye4oaFhJn4sI52zGCnNzKBYv5eS/Ylkp+8hK+sQ+rRUdm6LIz4ulrD1kUiSDKvVxveZGZxOJxOTk/gWFjCJldcwMvpGDJM0EVoxQZICBOHv/2KNDHmQEpV6rfg/bm9n8dMnPG43Ho8Hn9eL0Wjy33BkxG8YG7sRmVyOSqVGqVSh+B8KpXhV6nVC1NbWJkRLS0u43G4mp1wrK68YxmzYSKBMLoRBCuUqKFRq1Gv9hi3Nd8XhvV4fM+4pfs59w2TyJ3z3bsxvqIuKFqv+MQ0IlK1CoDyIIIVKiHp7e/lXw7O/aHTBQeMRwT1/MchXjwdpy9ZtrA+PQKuLIlKrWwWtLhpddAzBIRrOn6+ir+8Jjzs7uf2gk5r7dlIz9ISEaLhy9Ro2m43f71HxyOBtiZYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/4ff481310257981b89a808f5479e84c8/e4706/InstarVision2_PTZ-Tour_03.avif 230w", "/de/static/4ff481310257981b89a808f5479e84c8/d1af7/InstarVision2_PTZ-Tour_03.avif 460w", "/de/static/4ff481310257981b89a808f5479e84c8/7f308/InstarVision2_PTZ-Tour_03.avif 920w", "/de/static/4ff481310257981b89a808f5479e84c8/e3723/InstarVision2_PTZ-Tour_03.avif 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/4ff481310257981b89a808f5479e84c8/a0b58/InstarVision2_PTZ-Tour_03.webp 230w", "/de/static/4ff481310257981b89a808f5479e84c8/bc10c/InstarVision2_PTZ-Tour_03.webp 460w", "/de/static/4ff481310257981b89a808f5479e84c8/966d8/InstarVision2_PTZ-Tour_03.webp 920w", "/de/static/4ff481310257981b89a808f5479e84c8/a9a89/InstarVision2_PTZ-Tour_03.webp 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/4ff481310257981b89a808f5479e84c8/81c8e/InstarVision2_PTZ-Tour_03.png 230w", "/de/static/4ff481310257981b89a808f5479e84c8/08a84/InstarVision2_PTZ-Tour_03.png 460w", "/de/static/4ff481310257981b89a808f5479e84c8/c0255/InstarVision2_PTZ-Tour_03.png 920w", "/de/static/4ff481310257981b89a808f5479e84c8/2bef9/InstarVision2_PTZ-Tour_03.png 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/4ff481310257981b89a808f5479e84c8/c0255/InstarVision2_PTZ-Tour_03.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><strong parentName="p">{`3`}</strong>{` - Bewegen Sie jetzt die Kamera in die Position Zwei Ihrer Kamera Tour. Klicken Sie danach auf die 2 unterhalb des Drop-down Menüs. Die Zahl wird kurz in einem stärkeren Font dargestellt und die Position gespeichert.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/2bef9/InstarVision2_PTZ-Tour_04.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACtUlEQVQoz2WSa0jTYRTGX9t0bkWaps5ZBnYjifoQRNnsAl20G5pdzE0tUkjXRbI0UsQyi8yuWEiJhhrlZSutvnX9YN9yRWV+SijZSJfLuUWF+Yu9//KDHXh4H87hPOc5h1eY85JJ3p5AaWEe+YcyyT6SzoGSYnIsZorKCsg7lMP8+QsICQ3HmLgSozGR9UkbWbtuAwkrVhA3ew4RkXouX7rMPZsNkWJJZFvuMh7da+PkuWPkl23B9tJOer6FfYezuXi1nNjYaIQQ1NXdxOF00vPsOe9fvOBTfz8pKamy1m610tvbi9hv2UHl8T08v3WF2gvVXCs9xu3W+1TcuMsWUyq7CpdgmBUqmzo6OvDH8IcPePv6JM/Kypa17m47Y2NjiLMXK6k5Xc6dsmIaywq5WlxAfUUpNTW17Mzei3HzIqIM4YqL9nbcbjdenw+Px8PQ0BDmzExZ6+p6ycjICKK86ihnThTQcKqE60X5HMzdy5Xig1QXHcaSkcbylYsJi1Actra2SlcDg4NSzB/puzNk7dWrbhw/xhC7t65l85pV7NiUTMrqBOLnxbFm6WKSEpeyM8nIwvi5TJ0WhhBq2q02vg97+Nz3EYfTgc/nw5yZhRAB2F+/kQNEpN4gJ/iTImASk1RqRIBKcn9eFahBO3mK5G02Gz8dTlw9PbjcbnxeLyaTWbmh3a4IzpgZi1odSLBWhyZYS5AmWL4K/FyHVqcINjc1y6bR0VG5tvPLwPjK44IxM2JRqQPHxSZCo9Wh++uwob5eHt7r9eEe/MIvzzfMZsXh27fvFEF9tEGu6xf1rzsRqsAggjRa2dTZ2cm/6B7+zY0BSDMp3+bxk6d8dbkQC+IXEj49gih9NJFR+v8QpTegN8QwNSSUkpJSHjx4SFtLC9eaWqhotLEueRMhIaFUna/GarXyB1QW7PFW8b/9AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f8c1ee77254da8344a15d4bbab9f2d50/e4706/InstarVision2_PTZ-Tour_04.avif 230w", "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/d1af7/InstarVision2_PTZ-Tour_04.avif 460w", "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/7f308/InstarVision2_PTZ-Tour_04.avif 920w", "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/e3723/InstarVision2_PTZ-Tour_04.avif 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/f8c1ee77254da8344a15d4bbab9f2d50/a0b58/InstarVision2_PTZ-Tour_04.webp 230w", "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/bc10c/InstarVision2_PTZ-Tour_04.webp 460w", "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/966d8/InstarVision2_PTZ-Tour_04.webp 920w", "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/a9a89/InstarVision2_PTZ-Tour_04.webp 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f8c1ee77254da8344a15d4bbab9f2d50/81c8e/InstarVision2_PTZ-Tour_04.png 230w", "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/08a84/InstarVision2_PTZ-Tour_04.png 460w", "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/c0255/InstarVision2_PTZ-Tour_04.png 920w", "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/2bef9/InstarVision2_PTZ-Tour_04.png 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/f8c1ee77254da8344a15d4bbab9f2d50/c0255/InstarVision2_PTZ-Tour_04.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><strong parentName="p">{`4`}</strong>{` - Bewegen Sie jetzt die Kamera in die Position Drei Ihrer Kamera Tour. Klicken Sie danach auf die 3 unterhalb des Drop-down Menüs. Die Zahl wird kurz in einem stärkeren Font dargestellt und die Position gespeichert.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/518f1113e61bc25c3ec0edccf541768c/2bef9/InstarVision2_PTZ-Tour_05.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACo0lEQVQoz2WRX0iTURjGz5y675ul/dE55zLpJkqTiCiaqCnZhRrZ8qL8U85Nl5YjHWwqplSUzVwrtCyCFlqp+zTdRFsYhWRXZmKg6G0aznJqyNwg8YmdiV3swMN5v/Pw/L73PYd0vxvGq4FhdAx9Qff7TzBz3TA8NaL6tg7aWg1Mzx8hPiEBoaG7cEKWiJSTqcjIyER6+mkkJSUjLv4QwiNEMJlM4CwWEHVVCbQ3KtFYXQq99gJyr2ShqroETQ06XCuXo6IsD1KJCIQQmM1mOBwLmJqawuTkJObm5nAxN5d6Fo7DzPQ0SFNNKZ4Z76Dz4X3U6QtQppOj+UEl7ObHsL1sQf+bdiTEx9GQ3W6Hdy0vL8PlctFaqVJR7+vYGLCxAfK6oR4tGgVMV/PxTJOH2qIMGLVycPfKYa9VYkBXgP17pTRktVopzO12090rlaqYep9HRrC6ugrS+6QRrXo1DBUqGNU54GrU+HirHBbNebzQKtB2U4sYaTQN9fX10a4cDgdWVlZofbmwkHqjo6PA2iJI/tlMnJIdQ2qyDGmyI8hJOYpLaceRnXgY5+TZqKy4jtjYfSCEB5utn3Y3+2MW8/Pz8Hg8UG52+G18nP6AhIvE9IDwAkB4fBAS4BOtedQTsCFbI3vcbtqh0+mkcIWi6P8deoHSPTHgBwaBYYUQMAwEDAuGYenu/WaFIWBDtvlesstCQ+vr6/i14MCS87c/MFrqA3oBwQLGTwJWCOEmsL29jY655nLh54ITS66/UBQpqTcx8d0HFEdJ6GheaAA/0E/8oGAEC1gaGhwcxNZanAH+TKBYqaDe0NAHeg3kwME47A6PQKQ4CqJIsZ8ixRKIJdEIDduJuvp6WK02dHRx6Gy9i95mPc5kZWJ72A4YDAa87enBP3EV+OXWoI3pAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/518f1113e61bc25c3ec0edccf541768c/e4706/InstarVision2_PTZ-Tour_05.avif 230w", "/de/static/518f1113e61bc25c3ec0edccf541768c/d1af7/InstarVision2_PTZ-Tour_05.avif 460w", "/de/static/518f1113e61bc25c3ec0edccf541768c/7f308/InstarVision2_PTZ-Tour_05.avif 920w", "/de/static/518f1113e61bc25c3ec0edccf541768c/e3723/InstarVision2_PTZ-Tour_05.avif 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/518f1113e61bc25c3ec0edccf541768c/a0b58/InstarVision2_PTZ-Tour_05.webp 230w", "/de/static/518f1113e61bc25c3ec0edccf541768c/bc10c/InstarVision2_PTZ-Tour_05.webp 460w", "/de/static/518f1113e61bc25c3ec0edccf541768c/966d8/InstarVision2_PTZ-Tour_05.webp 920w", "/de/static/518f1113e61bc25c3ec0edccf541768c/a9a89/InstarVision2_PTZ-Tour_05.webp 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/518f1113e61bc25c3ec0edccf541768c/81c8e/InstarVision2_PTZ-Tour_05.png 230w", "/de/static/518f1113e61bc25c3ec0edccf541768c/08a84/InstarVision2_PTZ-Tour_05.png 460w", "/de/static/518f1113e61bc25c3ec0edccf541768c/c0255/InstarVision2_PTZ-Tour_05.png 920w", "/de/static/518f1113e61bc25c3ec0edccf541768c/2bef9/InstarVision2_PTZ-Tour_05.png 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/518f1113e61bc25c3ec0edccf541768c/c0255/InstarVision2_PTZ-Tour_05.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><strong parentName="p">{`5`}</strong>{` - Geben Sie eine Anzahl an Zyklen ein, die die Kamera für die Tour durchlaufen soll (1 - 999999999), eine Pause, die die Kamera an den jeweiligen Positionen verweilen soll (min. 10s) und die Positionen, die Sie für die Tour nutzen möchten - jeweils mit einem Komma getrennt (z.B. 1,2,3). Klicken Sie danach auf START um die Tour zu beginnen.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      